import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useUser } from '@adsk/alloy-provider';
import theme from '@adsk/alloy-react-theme';
import i18n from '../../utils/i18n';
import ProjectsHeaderTitleLoader from './ProjectsHeaderTitleLoader';

const ProjectsHeaderTitlesContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const ProjectsHeaderTitle = styled.span({
  ...theme.typography.title,
  color: theme.colors.charcoal900,
});

const ProjectsHeaderSubtitle = styled.span({
  ...theme.typography.heading2,
  color: theme.colors.charcoal700,
  marginTop: 6,
});

type ProjectsHeaderTitles = {
  showUserHomeTabLoading?: boolean;
  showUserHomeTab?: boolean;
};

const ProjectsHeaderTitles: FC<ProjectsHeaderTitles> = ({
  showUserHomeTabLoading,
  showUserHomeTab,
}) => {
  const { user } = useUser();

  return (
    <ProjectsHeaderTitlesContainer>
      {showUserHomeTabLoading ? (
        <ProjectsHeaderTitleLoader />
      ) : (
        <ProjectsHeaderTitle>
          {showUserHomeTab
            ? `${i18n.t('WELCOME', { firstName: user?.firstName || '' })}`
            : i18n.t('PROJECT_LIST')}
        </ProjectsHeaderTitle>
      )}
      {!showUserHomeTabLoading && showUserHomeTab && (
        <ProjectsHeaderSubtitle>
          {i18n.t('MY_HOME_SUBTITLE')}
        </ProjectsHeaderSubtitle>
      )}
    </ProjectsHeaderTitlesContainer>
  );
};

ProjectsHeaderTitles.propTypes = {
  showUserHomeTab: PropTypes.bool,
  showUserHomeTabLoading: PropTypes.bool,
};

export default ProjectsHeaderTitles;
